<template>
	<div>
		<!-- 联盟中不展示导航栏-->
		<Nav v-if="['fromWX', 'fromBD', 'fromZFB', 'fromTT', 'fromTZ'].indexOf(pagefrom) === -1  && resumeType !== 3"></Nav>
		<transition name="slide-left">
			<keep-alive>
				<router-view></router-view>
			</keep-alive>
		</transition>
	</div>
</template>

<script>
import Nav from "./components/nav";
import { mapGetters } from "vuex";
import { getConfigOtherData } from "./api/configData";
import util from './util';
// import vconsole from 'vconsole';
// const vConsole = new vconsole();

export default {
	name: "app",
	components: {
		Nav
	},
	computed: {
		...mapGetters(["resumeType", "pagefromLog", "pagetypeLog", "pagefrom"])
	},
	mounted() {
		setTimeout(() => {
			window.clickLog &&
				window.clickLog(
					"from=jlfb_fillout_normal_all" + this.pagetypeLog
				);
			window.clickLog &&
				window.clickLog("from=jlfb_fillout_normal" + this.pagefromLog);

			/*
			*简历发布来源：微信：70百度：71头条：70支付宝：70
			*/
			if([70,71].indexOf(parseInt(util.getParamVal('sourceid'),10)) > -1) {
					window.clickLog && clickLog("from=page1_show");
      }
		}, 200);

		this.getConfigOtherData();
	},
	methods:{
		getConfigOtherData(){
			getConfigOtherData().then(data => {
				this.$store.commit('SET_ALLCONFIGOTHERDATA', data);
			})
		}
	}
};
</script>

<style lang='scss'>
@import "./assets/style/public.scss";
.slide-left-enter,
.slide-right-leave-active {
	opacity: 0;
	-webkit-transform: translate(30px, 0);
	transform: translate(30px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
	opacity: 0;
	-webkit-transform: translate(-30px, 0);
	transform: translate(-30px, 0);
}
</style>



// WEBPACK FOOTER //
// App.vue?5cf51f92